import http from "../../shared/mediaHttp"
import { NoSuchFileOrDirectoryException } from "../../shared/exceptions"
import Vue from 'vue'
import { uniqBy } from "lodash"

const media = {
    state: {
        library: null,
        items: {},
        dirs: [],
        libraries: null
    },
    actions: {
        fetchLibraries({commit}) {
            return new Promise((resolve, reject) => {
                http.get("/v1/dms/media/library/list")
                .then((resp) => {
                    commit('SET_LIBRARIES', resp.data)

                    resolve(resp.data)
                }).catch((err) => {
                    console.error(err)
                    if (!err.status)
                        reject(new Error("Media library currently unavailable, please try again later."))
                })
            })
        },

        fetchLibraryInfo({commit}, uuid) {
            return new Promise((resolve, reject) => {
                http.get("/v1/dms/media/library/info/" + uuid)
                .then((resp) => {
                    resp.data.roles = resp.data.roles.map(r => {
                        return r.role_uuid;
                    })

                    commit('SET_LIBRARY', resp.data)
                    resolve(resp.data)
                }).catch((err) => {
                    if (!err.status) {
                        reject(new Error("Media library currently unavailable, please try again later."))
                    }
                    
                    reject(new NoSuchFileOrDirectoryException("Unable to load media file"))
                })
            })
        },

        fetchMedia({commit}, payload) {
            return new Promise((resolve, reject) => {
                this._vm.$media.list({path: payload.path, lib: payload.uuid, keyword: payload.keyword, last_key: payload.last_key, limit: payload.limit})
                .then((resp) => {
                    resp.data = resp.data || []

                    if (!resp.data.status && resp.data.code == 1001) {
                        throw new NoSuchFileOrDirectoryException()
                    } 

                    commit('SET_MEDIA', {path: payload.path, results: resp.data})
                    resolve(resp.data)
                }).catch((err) => {
                    console.error(err)
                    reject(new NoSuchFileOrDirectoryException("Unable to load media file"))
                })
            })
        },

        searchMedia({commit}, payload) {
            return new Promise((resolve, reject) => {
                this._vm.$media.list({path: payload.path, lib: payload.uuid, keyword: payload.keyword})
                .then((resp) => {
                    resp.data = resp.data || []

                    if (!resp.data.status && resp.data.code == 1001) {
                        throw new NoSuchFileOrDirectoryException()
                    }

                    resolve(resp.data)
                }).catch((err) => {

                    reject(new NoSuchFileOrDirectoryException("Unable to load media file"))
                })
            })
        },

        fetchDirs({commit}, payload) {
            return new Promise((resolve, reject) => {
                http.post(`/v2/dms/media/library/${payload.uuid}/dirs`, {path: payload.path})
                .then((resp) => {
                    resolve(resp.data)
                }).catch((err) => {
                    if (!err.status) {
                        reject(new Error("Media library currently unavailable, please try again later."))
                    }

                    reject(new NoSuchFileOrDirectoryException("Unable to load media file"))
                })
            })
        },

        deleteMedia({commit}, payload) {
            return new Promise((resolve, reject) => {
                http.post("/v1/dms/media/delete", {items: payload.items, library_uuid: payload.library_uuid})
                .then((resp) => {
                    if (!resp.data.status && resp.data.code == 3001) {
                        throw new NoSuchFileOrDirectoryException(resp.data.message)
                    } 

                    commit('REMOVE_MEDIA', {path: payload.path, items: payload.items})
                    resolve(resp.data)
                }).catch((err) => {
                    reject(new NoSuchFileOrDirectoryException(err.message))
                })
            })
        },

        uploadMedia({commit}, payload) {
            return new Promise((resolve, reject) => {
                let files = payload.files
                let formData = new FormData();
                
                let count = 0
                files.forEach((file, index) => {
                    formData.append('file', file)
                    count++
                })

                if (count == files.length) {
                    formData.append('path', payload.uploadDir)
                    formData.append('uuid', payload.uuid)
                    if (payload.expiresAt)
                        formData.append('expiresAt', new Date(payload.expiresAt).toISOString())

                    if (!_.isEmpty(payload.metadata))    
                        formData.append('metadata', JSON.stringify(payload.metadata))

                    if (payload.public) {
                        formData.append('is_public', "true")
                    }

                    http.post("/v2/dms/media/upload", formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((resp) => {
                        resolve(resp)
                    }).catch(error => {
                        reject(error)
                    })
                }
             });
        }
    },
    mutations: {
        SET_MEDIA (state, payload) {
            let p = state.items[payload.path] || []
            let results = p.concat(payload.results)

            // fix for duplicates
            const map = new Map()
            for(const result of results) {
                map.set(result.local_url, result)
            }

            Vue.set(state.items, payload.path, [...map.values()])
        },

        CLEAN_MEDIA (state) {
            state.items = {}
        },

        SET_DIRS (state, dirs) {
            Vue.set(state, "dirs", dirs)
        },

        SET_LIBRARY (state, data) {
            state.library = data
        },

        SET_LIBRARIES (state, data) {
            state.libraries = data
        },

        ADD_LIBRARY (state, lib) {
            if (!state.libraries) state.libraries = []
            
            state.libraries.push(lib)
        },

        APPEND_MEDIA (state, payload) {
            let media = state.items[payload.path]

            payload.results.forEach(result => {
                let found = media.find(m => {
                    return result.name == m.name
                })

                if (found !== undefined) {
                    media.map(m => {
                        if (m.name == result.name) {
                            return result
                        }
                    })
                } else {
                    media.push(result)
                }
            })

            Vue.set(state.items, payload.path, media)
        },

        MEDIA_UPLOADED (state, result) {
            let path = result.path
            if (path != "") {
                path = "/" + path
            }

            if (state.items[path] !== undefined) {
                let items = state.items[path]

                let found = items.find(m => {
                    return result.uuid == m.uuid
                })

                if (found !== undefined) {
                    items.map(m => {
                        if (m.uuid == result.uuid) {
                            m.status = result.status
                            m.path = result.public_path
                        }
                    })
                } else {
                    items.push(result)
                }
                

                Vue.set(state.items, path, items)
            }

            if (state.library !== null) {
                state.library.free_space -= result.size
            }
            
        },

        REMOVE_MEDIA (state, payload) {
            let path = payload.key.split("/")
            let fileName = path.pop()
            let dir = "/" + path.join("/")

            if (dir == "/") {
                dir = ""
            }

            let items = state.items[dir].filter(m => {
                return m.key != payload.key
            })

            Vue.set(state.items, dir, items)
        },

        REMOVE_DIR (state, path) {
            delete state.items[path]

            let dirPath = path.split("/")
            let prevDir = dirPath.slice(0, dirPath.length - 1).join("/")
            let dirDeleted = dirPath.pop()

            if (state.items[prevDir] !== undefined) {
                let items = state.items[prevDir].filter(m => {
                    return m.name != dirDeleted && m.mime_type == "dir"
                })

                Vue.set(state.items, prevDir, items)
            }
            
        },

        MOVE_MEDIA (state, payload) {
            let fromDir = state.items[payload.from]
            let toDir = state.items[payload.to]
            let itemUuids = payload.items
            // move fromDir into toDir
            itemUuids.forEach(uuid => {
                let index = fromDir.findIndex(item => {
                    return item.uuid == uuid
                })

                let item = fromDir[index]
                // if dir exist in storage
                if (toDir !== undefined) {
                    toDir.push(item)
                    Vue.set(state.items, payload.to, toDir)
                }

                fromDir.splice(index, 1)

                Vue.set(state.items, payload.from, fromDir)
            })
        }
    },
    getters: {
        library(state) {
            return state.library
        },

        libraries(state) {
            return state.libraries
        },

        dirs(state) {
            return state.dirs
        },

        media: (state) => (path) => {
            return uniqBy(state.items[path], )
        },

        mediaFile: (state) => (path, uuid) => {
            return state.items[path].find(m => {
                return m.uuid == uuid
            })
        },

        getLastItemInDir: (state) => (path) => {
            const p = state.items[path] || []
            const l = p.length

            return p[l - 1]
        }
    }
  }

export default media